import * as ng from 'angular';
import { NavListService } from './nav-list.service';

export class AppController {
   static $inject = ['navList'];

   constructor(private navList:NavListService) { }

   get showNav():boolean {
      return this.navList.showNav;
   }
}

ng.module('e360').component('app', {
   templateUrl: require('./app.html'),
   controller: AppController
});
